import './lib/recorder-core'
import './lib/wav'
import './lib/pcm'
import WebSocketConnectMethod from './lib/wsconnecter'
class EventEmitter {
  constructor() {
    this.events = {};
  }
  on(eventName, listener) {
    if (!this.events[eventName]) {
      this.events[eventName] = [];
    }
    this.events[eventName].push(listener);
  }
  emit(eventName, ...args) {
    const listeners = this.events[eventName];
    if (listeners) {
      listeners.forEach(listener => listener(...args));
    }
  }
  off(eventName, listener) {
    const listeners = this.events[eventName];
    if (listeners) {
      this.events[eventName] = listeners.filter(l => l !== listener);
    }
  }
}
class FunASR {
  constructor() {
    this.ws = null
    this.rec = null
    this.rec_text = "";  // for online rec asr result
    this.offline_text = ""; // for offline rec asr result
    this.file_ext = "";
    this.sampleBuf = new Int16Array();
    this.isRec = false
    this.ready = false
    this.eventEmitter = new EventEmitter();
    this.config = {
      mode: '2pass',//2pass-offline    online    offline
    }
    this.start = this.start.bind(this)
    this.stop = this.stop.bind(this)
    this.init()
  }
  init() {
    const that = this
    // 连接; 定义socket连接类对象与语音对象
    that.ws = new WebSocketConnectMethod({
      msgHandle: this.getJsonMessage.bind(that),
      stateHandle: (connState) => {
        if (connState === 0) { //on open
          console.log('连接ws成功!')
          //直接开始录音
          that.record()
        } else if (connState === 1) {
          //stop();
        } else if (connState === 2) {
          stop();
          console.error('连接ws失败！')
          that.eventEmitter('error');
        }
      },
      itn: that.config.itn,
      mode: that.config.mode,
    })
    // 录音; 定义录音对象,wav格式
    that.rec = Recorder({
      type: "pcm",
      bitRate: 16,
      sampleRate: 16000,
      onProcess: that.recProcess.bind(that)
    });
    setTimeout(() => {
      that.eventEmitter.emit('ready', this);
    }, 0);
  }
  on(eventName, listener) {
    this.eventEmitter.on(eventName, listener);
  }
  // 语音识别结果; 对jsonMsg数据解析,将识别结果附加到编辑框中
  getJsonMessage(jsonMsg) {
    const that = this
    // console.log("message: " + JSON.parse(jsonMsg.data)['text']);
    const rectxt = "" + JSON.parse(jsonMsg.data)['text'];
    const asrmodel = JSON.parse(jsonMsg.data)['mode'];
    const is_final = JSON.parse(jsonMsg.data)['is_final'];
    const timestamp = JSON.parse(jsonMsg.data)['timestamp'];
    if (asrmodel == "2pass-offline" || asrmodel == "offline") {
      that.offline_text = that.offline_text + that.handleWithTimestamp(rectxt, timestamp); //rectxt; //.replace(/ +/g,"");
      that.rec_text = that.offline_text;
    }
    else {
      that.rec_text = that.rec_text + rectxt; //.replace(/ +/g,"");
    }
    // console.log("offline_text: " + asrmodel + "," + that.offline_text);
    // console.log("rec_text: " + that.rec_text);
    that.eventEmitter.emit('msg', that.rec_text);
  }
  handleWithTimestamp(tmptext, tmptime) {
    const partText = tmptext;
    console.log("tmptext: " + tmptext);
    console.log("tmptime: " + tmptime);

    if (tmptime == null || tmptime == "undefined" || tmptext.length <= 0) {
      return tmptext;
    }

    tmptext = tmptext.replace(/。|？|，|、|\?|\.|\ /g, ","); // in case there are a lot of "。"
    var words = tmptext.split(",");  // split to chinese sentence or english words
    var jsontime = JSON.parse(tmptime); //JSON.parse(tmptime.replace(/\]\]\[\[/g, "],[")); // in case there are a lot segments by VAD
    var char_index = 0; // index for timestamp
    var text_withtime = "";
    for (var i = 0; i < words.length; i++) {
      if (words[i] == "undefined" || words[i].length <= 0) {
        continue;
      }
      console.log("words===", words[i]);
      console.log("words: " + words[i] + ",time=" + jsontime[char_index][0] / 1000);
      if (/^[a-zA-Z]+$/.test(words[i])) {   // if it is english
        // text_withtime = text_withtime + jsontime[char_index][0] / 1000 + ":" + words[i] + "\n"; // 自定义：每段word内容格式
        text_withtime += partText; // word内容格式
        char_index = char_index + 1;  //for english, timestamp unit is about a word
      }
      else {
        // if it is chinese
        // text_withtime = text_withtime + jsontime[char_index][0] / 1000 + ":" + words[i] + "\n"; // 自定义：每段word内容格式
        text_withtime += partText; // word内容格式
        char_index = char_index + words[i].length; //for chinese, timestamp unit is about a char
      }
    }
    return text_withtime;
  }
  recProcess(buffer, powerLevel, bufferDuration, bufferSampleRate, newBufferIdx, asyncEnd) {
    const that = this
    if (that.isRec === true) {
      const data_48k = buffer[buffer.length - 1];
      const array_48k = new Array(data_48k);
      const data_16k = Recorder.SampleData(array_48k, bufferSampleRate, 16000).data;
      that.sampleBuf = Int16Array.from([...that.sampleBuf, ...data_16k]);
      const chunk_size = 960; // for asr chunk_size [5, 10, 5]
      while (that.sampleBuf.length >= chunk_size) {
        const sendBuf = that.sampleBuf.slice(0, chunk_size);
        that.sampleBuf = that.sampleBuf.slice(chunk_size, that.sampleBuf.length);
        that.ws.wsSend(sendBuf);
      }
    }
  }
  // 识别启动、停止、清空操作
  start() {
    const that = this
    //启动连接
    const ret = that.ws.wsStart(that.config.ws || ((location.origin.includes('https://') ? 'wss://' : 'ws://') + location.host + '/funasr-online/'));
    if (ret == 1) {
      that.isRec = true;
      return 1;
    }
  }
  record() {
    const that = this
    that.rec.open(function () {
      that.rec.start();
      console.log("开始");
    });
  }
  stop() {
    const that = this
    const chunk_size = new Array(5, 10, 5);
    const request = {
      "chunk_size": chunk_size,
      "wav_name": "h5",
      "is_speaking": false,
      "chunk_interval": 10,
      "mode": that.config.mode,
    };
    console.log(request);
    if (that.sampleBuf.length > 0) {
      that.ws.wsSend(that.sampleBuf);
      console.log("sampleBuf.length" + that.sampleBuf.length);
      that.sampleBuf = new Int16Array();
    }
    that.ws.wsSend(JSON.stringify(request));
    // 控件状态更新
    that.isRec = false;
    // console.log("发送完数据,请等候,正在识别...")
    setTimeout(function () {
      that.ws.wsStop();
    }, 3000);
    that.rec.stop(function (blob, duration) {
      console.log(blob);
      var audioBlob = Recorder.pcm2wav({ sampleRate: 16000, bitRate: 16, blob: blob },
        function (theblob, duration) {
          //生成wav文件
          console.log(theblob);
          that.eventEmitter.emit('audio', theblob);
        }, function (msg) {
          console.error(msg);
        }
      );
    }, function (errMsg) {
      console.log("errMsg: " + errMsg);
    });
  }
}

export default FunASR;